/* 
This file contains all the options so that we don't have to define
options again and again.
*/

window.FusionCharts.register("theme", {
  name: "analysis",
  theme: {
    base: {
      chart: {
        bgAlpha: "0",
        canvasBgAlpha: "0",
        baseFont: "basefont-regular",
        baseFontSize: "14",
        baseFontBold: "0",
        chartBottomMargin: "0",
        chartTopMargin: "10",
        chartLeftMargin: "0",
        chartRightMargin: "0",
        canvasBottomMargin: "0",
        canvasTopMargin: "0",
        canvasRightMargin: "0",
        canvasLeftMargin: "0",
        showBorder: "0",
        showCanvasBorder: "0",
        baseFontColor: "#ffffff",
        captionFontBold: "0",
        captionFontSize: "14",
        subCaptionFontSize: "14",
        tooltipColor: "#ffffff",
        tooltipBgColor: "#000000",
        tooltipBgAlpha: "60",
        tooltipPadding: "5",
        toolTipBorderAlpha: "10",
        toolTipBorderRadius: "3",
        showValues: "0",
        legendBgAlpha: "0",
        legendBorderAlpha: "0",
        legendBorderThickness: "0"
      }
    },
    bar2d: {
      chart: {
        placeValuesInside: "0",
        usePlotGradientColor: "0",
        showAlternateVGridColor: "0",
        chartLeftMargin: "5",
        canvasLeftMargin: "5",
        divLineAlpha: "10",
        divLineColor: "#ffffff",
        captionFontColor: "#8091ab",
        paletteColors: "#1D91C0",
        valuePadding: "5",
        yAxisName: "Orders",
        yAxisNameAlpha: "50",
        yAxisNameFontSize: "12",
        yAxisNamePadding: "20",
        valueFontBold: "0",
        valueFontSize: "12",
        plotToolText: "<div>$label<br><b>$valueK orders</b>",
        captionAlignment: "left",
        captionPadding: "20"
      }
    },
    doughnut2d: {
      chart: {
        captionFontSize: "15",
        captionFontColor: "#8091ab",
        showLabels: "0",
        showValues: "0",
        use3DLighting: "0",
        showPlotBorder: "0",
        defaultCenterLabel: "75%",
        pieRadius: "45",
        doughnutRadius: "33",
        showTooltip: "0",
        enableRotation: "0",
        enableSlicing: "0",
        startingAngle: "90"
      }
    },
    geo: {
      chart: {
        captionFontSize: "14",
        captionFontColor: "#8091ab",
        legendScaleLineThickness: "0",
        legendaxisborderalpha: "0",
        legendShadow: "0",
        plotFillAlpha: "85",
        showBorder: "1",
        borderColor: "#ffffff",
        borderThickness: "0.3",
        nullEntityColor: "#17202e",
        nullEntityAlpha: "50",
        entityFillHoverColor: "#17202e",
        captionAlignment: "left",
        entityToolText: "<div>$lname<br><b>$value orders</b>",
        chartLeftMargin: "40"
      }
    }
  }
});
